import React, { useEffect, useState } from 'react';
import { Grid, Input, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { fonts, themes } from '../../themes/themes';
import uploadIcon from '../../../assets/images/upload_icon.svg';
import './DropAndSelect.css';
import { Box } from '@mui/system';
import ImageModelView from '../ImageViewer/ImageModelView';
import { useTranslation } from 'react-i18next';
import { commonServices } from '../../../api/services/commonServices';
import { useAppSelector } from '../../../infra/hooks';
import { log } from 'util';
import { payloadValidator } from '../../helper';
import toast from 'react-hot-toast';
interface IDropAndSelectProps {
  upload?: any;
  src?: any;
  onDelete?: any;
  isPDF?: boolean;
  pdfName?: any;
  disabledDeleteBtn?: boolean;
  isAttachmentSigned?: boolean;
}

const DropAndSelect = ({
  upload,
  src,
  onDelete,
  isPDF,
  disabledDeleteBtn,
  pdfName,
  isAttachmentSigned,
}: IDropAndSelectProps) => {
  const CustomInput = styled(Input)({
    display: 'none',
  });
  const { t } = useTranslation();
  const trans = t;
  const [isShow, setIsShow] = useState(false);
  const [openViewFullPicModal, setOpenViewFullPicModal] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const selector = useAppSelector((state) => state);
  const [docLink, setDocLink] = useState('');
  useEffect(() => {
    if (src) {
      let file_extension: any = src.substring(src.lastIndexOf('.') + 1);
      if (isAttachmentSigned) {
        file_extension = file_extension.substring(
          0,
          file_extension.lastIndexOf('?'),
        );
      }
      if (
        file_extension == 'jpeg' ||
        file_extension == 'jpg' ||
        file_extension == 'png' ||
        file_extension == 'giff' ||
        file_extension == 'tiff' ||
        file_extension == 'raw' ||
        file_extension.includes('blob:')
      ) {
        setIsImage(true);
      }
    } else {
      setIsImage(false);
    }

    if (isAttachmentSigned) {
      setDocLink(src);
    } else {
      const user_id: any = selector.authSlice.user_id;
      const companyID: any = selector.authSlice.company_id;
      const Payload = {
        filepath: src,
        fullpath: true,
      };
      commonServices
        .getFilePath(companyID, user_id, Payload)
        .then((res: any) => {
          setDocLink(res);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [src]);
  const handleDownload = async (_file: any) => {
    const response = await fetch(_file);
    const blob = await response.blob();
    const _url: any = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = _url;
    link.setAttribute('download', '');

    link.click();
  };

  const handleFileUpload = (e: any) => {
    const validate: any = payloadValidator(e.target.files[0]);
    if (validate.isValid) upload(e)
    else toast.error(validate.message);
  }

  return isPDF ? (
    <Grid container>
      <Grid item xs={10} style={{ cursor: 'pointer' }}>
        <Typography
          style={{
            color: themes.greyDefault_500,
            fontFamily: fonts.fontFamily,
            fontSize: fonts.title,
          }}
        >
          {pdfName}
        </Typography>
        <i className="las la-file-pdf" style={{ fontSize: '48px' }} />
      </Grid>
      <Grid item xs={2}>
        <Box className="delete-box">
          <i
            className="las la-trash-alt"
            color={themes.defaultError}
            onClick={onDelete}
            style={{
              cursor: 'pointer',
            }}
          />
        </Box>
      </Grid>
    </Grid>
  ) : src?.length ? (
    <Grid
      container
      className="image_grid"
      onMouseOver={() => {
        setIsShow(true);
      }}
      onMouseLeave={() => setIsShow(false)}
      style={{
        opacity: isShow ? '0.5' : '1',
      }}
    >
      <Grid item xs={12} style={{ marginTop: '0.5em' }}>
        {!isImage ? (
          <div>
            <i className="las la-file-pdf" style={{ fontSize: '48px' }} />
            <Typography
              style={{
                color: themes.greyDefault_500,
                fontSize: fonts.subtitle,
                fontFamily: fonts.fontFamily,
              }}
            >
              {' '}
              {trans('File Attached')}
            </Typography>
          </div>
        ) : (
          <div>
            <i className="las la-file-image" style={{ fontSize: '48px' }} />
            <Typography
              style={{
                color: themes.greyDefault_500,
                fontSize: fonts.subtitle,
                fontFamily: fonts.fontFamily,
              }}
            >
              {' '}
              {trans('File Attached')}
            </Typography>
          </div>
        )}
      </Grid>
      {isShow && (
        <Grid
          item
          xs={12}
          style={{
            zIndex: '1',
            marginTop: '-3.5em',
            marginLeft: '75px',
            display: 'flex',
          }}
        >
          {!disabledDeleteBtn && (
            <Box
              className="delete-box"
              style={{ marginLeft: '1em', marginRight: '1em' }}
            >
              <i
                className="las la-trash-alt"
                color={themes.defaultError}
                onClick={onDelete}
              />
            </Box>
          )}
          <Box className="delete-box">
            <i
              className="las la-eye"
              color={themes.defaultError}
              onClick={() => setOpenViewFullPicModal(true)}
            />
          </Box>
        </Grid>
      )}
      {openViewFullPicModal && (
        <>
          <ImageModelView
            url={docLink}
            isOpen={openViewFullPicModal}
            onClose={() => setOpenViewFullPicModal(false)}
            isAttachmentSigned={true}
          />
        </>
      )}
    </Grid>
  ) : (
    <label style={{ width: '230px' }} htmlFor="icon-button-file">
      <Grid container className="main-grid">
        <CustomInput id="icon-button-file" type="file" onChange={handleFileUpload} />

        <Grid
          item
          xs={12}
          style={{
            textAlign: 'center',
          }}
        >
          <img
            src={uploadIcon}
            style={{
              width: '70px',
              height: '70px',
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography
            style={{
              color: themes.blackDefault,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.title,
              textAlign: 'center',
            }}
          >
            {trans('Drop or select file')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            style={{
              color: themes.greyDefault_500,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textAlign: 'center',
            }}
          >
            {trans('Drop files here or click')}{' '}
            <span style={{ color: themes.defaultSuccess }}>
              {trans('browse')}
            </span>{' '}
            {trans('through your machine')}
          </Typography>
        </Grid>
      </Grid>
    </label>
  );
};

export default DropAndSelect;
